ui-slide {
  display: block;
  /* stylelint-disable-next-line plugin/no-unsupported-browser-features */
  cursor: grab;

  &:active {
    /* stylelint-disable-next-line plugin/no-unsupported-browser-features */
    cursor: grabbing;
  }
}
